import { create } from 'zustand';

interface ChatNavigationState {
  pendingConversationId: string | null;
  pendingMessageId: string | null;
  
  // Navigate to a specific conversation (optionally highlighting a message)
  navigateToConversation: (conversationId: string, messageId?: string) => void;
  
  // Clear navigation state after it's been consumed
  clearNavigation: () => void;
}

export const useChatNavigationStore = create<ChatNavigationState>((set) => ({
  pendingConversationId: null,
  pendingMessageId: null,
  
  navigateToConversation: (conversationId, messageId) => {
    set({
      pendingConversationId: conversationId,
      pendingMessageId: messageId || null,
    });
  },
  
  clearNavigation: () => {
    set({
      pendingConversationId: null,
      pendingMessageId: null,
    });
  },
}));
